import React from 'react';
import styled from 'styled-components/macro';
import { useWorkspace, useComposition } from '../../context';
import AddToCartButtonBase from '../common/AddToCartButtonBase';
import SaveForLaterButton from './infopage/SaveForLaterButton';
import CancelSaveCompositionButton from './CancelSaveCompositionButton';
import SaveCompositionButton from './SaveCompositionButton';
import UploadPhotosButton from './UploadPhotosButton';
import { FooterPrice } from './FooterPrice';


export const ButtonsGroup = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: center;
    align-items: stretch;
    width: 100%;
    max-width: ${(props) => (props.$maxWidth ? props.$maxWidth : '500px')};
    margin: 0 auto;
    
    > * {
        width: 50% !important;
        
        span {
            font-size: 13px;
        }
    }

    @media (max-width: ${props => props.$columnBreakpoint}px) {
        flex-direction: column;
        
        > * {
            width: 100% !important;
        }
    }
`;

const Row = styled.div`
    display: flex;
    flex-direction: row;
    gap: 12px;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
`;

export const WorkspaceFloatingBottom = () => {
    const { isEditMode } = useWorkspace();
    const { missingImages } = useComposition();

    return (
        <Row>
            <FooterPrice/>
            <ButtonsGroup $columnBreakpoint={200}>
                {isEditMode &&
                    <>
                        <CancelSaveCompositionButton />
                        <SaveCompositionButton />
                    </>
                }
                {!isEditMode &&
                    <>
                        <SaveForLaterButton className="uppercase" />
                        { missingImages ? <UploadPhotosButton/> : <AddToCartButtonBase className="action-button uppercase" />}
                    </>
                }
            </ButtonsGroup>
        </Row>
    )
}
